import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function TestConnection() {
  const [status, setStatus] = useState('Testing...');
  const [error, setError] = useState(null);
  const [dbStatus, setDbStatus] = useState('Testing...');
  const [dbError, setDbError] = useState(null);

  useEffect(() => {
    // Test API connection
    const testApiConnection = async () => {
      try {
        const response = await fetch(api.baseURL + '/test-connection.php');
        const data = await response.json();
        setStatus(data.status === 'success' ? '✅ Connected' : '❌ Failed');
      } catch (err) {
        setStatus('❌ Failed');
        setError(err.message);
      }
    };

    // Test Database connection
    const testDbConnection = async () => {
      try {
        const response = await fetch(api.baseURL + '/test-db.php');
        const data = await response.json();
        if (data.status === 'success') {
          setDbStatus(`✅ Connected to ${data.database}`);
        } else {
          setDbStatus('❌ Failed');
          setDbError(data.error || 'Unknown error');
        }
      } catch (err) {
        setDbStatus('❌ Failed');
        setDbError(err.message);
      }
    };

    testApiConnection();
    testDbConnection();
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Connection Test</h1>
      
      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">API Connection</h2>
        <div className="flex items-center">
          <span className="mr-2">{status}</span>
          {error && <span className="text-red-500 ml-4">{error}</span>}
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold mb-4">Database Connection</h2>
        <div className="flex items-center">
          <span className="mr-2">{dbStatus}</span>
          {dbError && <span className="text-red-500 ml-4">{dbError}</span>}
        </div>
      </div>

      <div className="mt-8 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
        <h3 className="font-semibold text-yellow-800 mb-2">Troubleshooting Steps:</h3>
        <ol className="list-decimal list-inside space-y-2 text-yellow-700">
          <li>Check if the backend server is running</li>
          <li>Verify the database credentials in the .env file</li>
          <li>Ensure the database exists and the user has proper permissions</li>
          <li>Check the browser's developer console for detailed error messages</li>
          <li>Check the server error logs for any PHP or database errors</li>
        </ol>
      </div>
    </div>
  );
}
